import { cssToken } from "@certn/cascadia";
import { Grid, GridItem, FieldErrors } from "@certn/cascadia-react";
import { css, CSSInterpolation } from "@emotion/css";
import { JsonFormsDispatch } from "@jsonforms/react";
import { useContext } from "react";

import { BaseLayout } from "./BaseLayout";
import { BaseLayoutContent } from "./BaseLayoutContent";
import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import {
  CascadiaLayoutProps,
  withCascadiaLayoutProps,
} from "../wrappers/withCascadiaLayoutProps";
import { getScopeLookupPath } from "../controls/utils";

function HorizontalLayout(props: CascadiaLayoutProps) {
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const { options } = props;

  const getClassFromOptions = () => {
    const styles: CSSInterpolation = {};
    if (options.verticalMargin) {
      styles["marginTop"] = cssToken(options.verticalMargin);
      styles["marginBottom"] = cssToken(options.verticalMargin);
    }
    return css(styles);
  };

  return (
    <BaseLayout
      {...props}
      testID="horizontal-layout"
      className={css(styles.margin, getClassFromOptions())}
    >
      <Grid form>
        <BaseLayoutContent>
          {(renderProps) => {
            const colSpan = renderProps.uischema.options?.colSpan;
            const path =
              renderProps.path +
              "." +
              getScopeLookupPath(
                (renderProps.uischema as { scope?: string })["scope"] || ""
              ).replace("properties.", "");

            return (
              <GridItem
                key={renderProps.key}
                span={colSpan}
                className={css(
                  isSummaryForPath?.(path) &&
                    css({ ".InnerContentItem": { margin: 0 } })
                )}
              >
                <JsonFormsDispatch {...renderProps} key={renderProps.key} />
              </GridItem>
            );
          }}
        </BaseLayoutContent>
      </Grid>
      {props.touched && <FieldErrors>{props.errors}</FieldErrors>}
    </BaseLayout>
  );
}

const styles = {
  margin: css({
    marginTop: "var(--space-4)",
    marginBottom: "var(--space-4)",
  }),
};

HorizontalLayout.displayName = "HorizontalLayout";

export const HorizontalLayoutRenderer =
  withCascadiaLayoutProps(HorizontalLayout);
